module.exports = __webpack_public_path__ + "assets/img/icon-newmember-2.b3a804ba.svg";